"use client"

import { ComponentConfig } from "@measured/puck"
import { RenderConfig } from "./RenderConfig"
import { TamdaExpressProductListProps } from "./types"

export const TamdaExpressProductList: ComponentConfig<TamdaExpressProductListProps> = {
  label: "Tamda Express | Product List",
  fields: {
    eanIds: {
      label: "EAN IDs",
      type: "textarea",
    },
    title: {
      label: "Title",
      type: "text",
    },
    className: {
      label: "Class Name",
      type: "text",
    },
  },
  defaultProps: {
    eanIds: "8595040006768",
    title: "SẢN PHẨM ĐỀ NGHỊ",
    className: "",
  },
  ...RenderConfig,
}
